import { render, staticRenderFns } from "./IntegrationSettingsPage.vue?vue&type=template&id=26a4626c&scoped=true"
import script from "./IntegrationSettingsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettingsPage.vue?vue&type=style&index=0&id=26a4626c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4626c",
  null
  
)

export default component.exports